document.addEventListener("DOMContentLoaded", setBadgeFontSize);
window.addEventListener("resize", setBadgeFontSize);

export function setBadgeFontSize() {
	const badge = document.querySelector(".loveli-percentage-sale-badge") || false;

	if (!badge) return;
	document.body.style.setProperty("--badge-font-size", badge.offsetWidth / 3 + "px");
}
